var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ticket-history-wrapper" },
    [
      _vm.showModal
        ? _c("Modal", {
            ref: "modal",
            staticClass: "flex ticket-history-modal",
            attrs: {
              "full-screen": _vm.isMobile,
              "show-footer": true,
              width: "800px",
              height: "500px",
            },
            on: {
              closeModal: _vm.closeModal,
              closeModalOutside: function ($event) {
                return _vm.closeModal("outside")
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "flex-center" }, [
                        _c("span", { staticClass: "product-name" }, [
                          _vm._v(" " + _vm._s(_vm.gameTitle) + " "),
                        ]),
                        _c("i", {
                          staticClass: "icon icon-close-a",
                          on: { click: _vm.closeModal },
                        }),
                      ]),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("TicketsHistory", {
                        ref: "ticketsHistory",
                        attrs: {
                          locale: _vm.config.locale,
                          "product-name-label": _vm.gameTitle,
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2129141179
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }